import script from "./ManagerAccountView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ManagerAccountView.vue?vue&type=script&lang=ts&setup=true"

import "./ManagerAccountView.vue?vue&type=style&index=0&id=9c50686e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c50686e"]])

export default __exports__